import { render, staticRenderFns } from "./TagItem.vue?vue&type=template&id=ef102c00&scoped=true"
import script from "./TagItem.vue?vue&type=script&lang=ts"
export * from "./TagItem.vue?vue&type=script&lang=ts"
import style0 from "./TagItem.vue?vue&type=style&index=0&id=ef102c00&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef102c00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef102c00')) {
      api.createRecord('ef102c00', component.options)
    } else {
      api.reload('ef102c00', component.options)
    }
    module.hot.accept("./TagItem.vue?vue&type=template&id=ef102c00&scoped=true", function () {
      api.rerender('ef102c00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/TagItem.vue"
export default component.exports